<template>
  <div>


    <FiltersTerapias @terapias-encontradas="recibirArray" :numSinCompletar ="sinCompletar" :numSinCobertura = "sinMsp" />
    
    <b-card class="principal">

      <b-table
        v-if="terapiasShow.length"
        bordered
        striped
        responsive
        :per-page="table.perPage"
        :current-page="table.page"
        :items="terapiasShow"
        :fields="tableFields"
      >
          <template #cell(terapia)="data">
    <span :title="data.item.terapia">
      {{ truncarTexto(data.item.terapia, 40) }}
    </span>
  </template>


        <template #cell(estadoTerapia)="data">
          <span 
            class="text-center"
            :class="data.item.estadoTerapia === '1' ? 'text-primary' : data.item.estadoTerapia === '2' ? 'text-warning' : 'text-success'"
          >
            {{ data.item.estadoTerapia === '1' 
              ? 'Creada' 
              : data.item.estadoTerapia === '2'
                ? 'Programada'
                : 'Terminada'
            }}
          </span>
        </template>
        
        <template #cell(acciones)="data">
          <div class="d-flex justify-content-end mx-1">
            <!-- <b-button
              :variant="data.item.estadoTerapia === '1' ? 'primary' : 'warning'"
              title="Programar"
              size="sm"
              @click="onShowModalProgramar(data.item.token)"
            >
              <i class="fas fa-calendar" style="color: white"/>
            </b-button> -->

            <b-button
              variant="primary"
             v-b-tooltip.hover title="Sesiones de terapia."
              size="sm"
              @click="onShowSesiones(data.item.token)"
            >
              <i class="fa-solid fa-pen-to-square"></i>
            </b-button>

          <b-button
            v-if="data.item.terapiaDetalles.tipoTerapia.id == 2 || data.item.terapiaDetalles.tipoTerapia.id == 1"
            v-b-tooltip.hover title="Descargar formulario 005"
            size="sm"
            class="ml-1"
             @click="generar005Terapia(data.item.token, data.item.paciente)"
          >
            005
          </b-button>
      
          <b-button
            v-else
            v-b-tooltip.hover title="Descargar formulario sesiones"
            size="sm"
            class="ml-1"
            @click="generarTerapiaFisica(data.item.token, data.item.paciente)"
          >
            PDF
          </b-button>
          

            <!-- <b-button
              variant="primary"
              title="MSP"
              size="sm"
              @click="onShowFormMsp(data.item.token)"
            >
              MSP
            </b-button> -->
<!-- 
            <b-button
              v-if="
                data.item.estadoTerapia === 'Terminado' ||
                  data.item.estadoTerapia === 'En Terapia'
              "
              variant="primary"
              size="sm"
              title="Historial de Terapias"
              @click="historialTerapia(data.item.idSolicitudTerapia)"
            >
              <i class="fas fa-file" style="color: white"></i>
            </b-button> -->
            <!-- <b-button
              variant="danger"
              size="sm"
              @click="removeItemid(data.item.idSolicitudTerapia)"
            >
              <font-awesome-icon icon="circle-xmark" style="color: white" />
            </b-button> -->
          </div>
        </template>

<!-- 
        <template #cell(informes)="data">
          <b-button
            v-b-tooltip.hover title="Descargar formulario 005"
            size="sm"
          >
            5
          </b-button>
        </template> -->

        
        <template #cell(coberturasSubidas)="data">
        <div v-if="data.item.tipoCobertura.descripcion === 'PARTICULAR'"><span>No Aplica</span></div>
        <div  v-else >
          {{ data.item.coberturasSubidas }}
        </div>
        </template> 
      </b-table>

      <div v-else class="text-center">
        <p>No se encontraron registros</p>
      </div>

      <b-col cols="12" class="mb-2">
        <b-pagination
          v-if="terapiasShow.length > 0"
          v-model="table.page"
          :total-rows="table.totalRows"
          :small="true"
          first-number
          last-number
          class="mb-0"
          align="center"
          prev-class="prev-item"
          next-class="next-item"
          @change="onChangePage"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </b-col>
    </b-card>

    <ModalProgramarTerapia />

    <FormSesionesTerapia />

    <!-- <ModalChangeDateTerapia
      :isVisible.sync="showModalEjecutar"
      :idTerapia="idTerapiaToEjecutar"
    />

    <ModalProcesarTerapia
      :isVisible.sync="showModalProcesar"
      :idTerapia="idTerapiaToProcesar"
    /> -->

  </div>
</template>

<script>

import { BootstrapVue } from 'bootstrap-vue';
import actions          from "@/assets/utils/utils";
import 'flatpickr/dist/flatpickr.css';

import { 
  ModalProgramarTerapia, 
  ModalChangeDateTerapia,
  ModalProcesarTerapia,
  FiltersTerapias,
  FormSesionesTerapia
} from "@/views/terapia/components";

import { terapiasService } from "../services";
import { getEstablecimientoLS } from '../../../shared/helpers';
import { terapiasMapper } from '../helpers';

export default {
  components: {
    ...BootstrapVue.components,

    ModalProgramarTerapia,
    ModalChangeDateTerapia,
    ModalProcesarTerapia,
    FiltersTerapias,
    FormSesionesTerapia
  },

  data() {
    return {
      terapiasShow: [],
      sinCompletar: '0',
      sinMsp: '0',
      table:{
        perPage: 10,
        page: 1,
        totalRows: 0,
      },

      tableFields:[
        

        {
          key: "paciente",
          label: "Paciente",
          sortable: true,
          thClass: "text-center",
        },

        {
          key: "fechaCita",
          label: "Fecha Atencion",
          sortable: true,
          thClass: "text-center",
        },

          {
          key: "doctor",
          label: "Doctor",
          sortable: true,
          thClass: "text-center",
        },


        {
          key: "terapia",
          label: "Terapia",
          sortable: true,
          thClass: "text-center",
        },
       

        {
          key: "tipoCobertura.descripcion",
          label: "Cobertura",
          sortable: true,
          thClass: "text-center",
        },

        {
          key: "sesionesProcesadas",
          label: "Sesiones Realizadas",
          sortable: true,
          thClass: "text-center",
        },

        // {
        //   key: "fechaProgramadaStr",
        //   label: "Fecha Programada",
        //   sortable: true,
        //   thClass: "text-center",
        // },
         {
          key: "coberturasSubidas",
          label: "Coberturas Subidas",
          sortable: true,
          thClass: "text-center",
        },

        // {
        //   key: "estadoTerapia",
        //   label: "Estado",
        //   sortable: true,
        //   thClass: "text-center",
        // },

      
        {
          key: "acciones",
          label: "acciones",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-right",
        },

        // {
        //   key: "informes",
        //   label: "informes",
        //   sortable: true,
        //   thClass: "text-center",
        //   tdClass: "text-right",
        // },
      ],

    } 
  },

  created() {
    this.loadDataTable();
  },

  mounted() {
    actions.setearTitulo("Terapias Programadas");
  },

  computed: {

  },

  methods: {
    recibirArray(array){
      console.log("recibo array", array)
      this.terapiasShow = array
    },
    truncarTexto(texto, maxLength) {
    if (!texto) return '';
    return texto.length > maxLength ? texto.slice(0, maxLength) + '...' : texto;
  },
    
    async loadDataTable() {

      const params = {
        establecimiento : getEstablecimientoLS().id,
      };

      const responseTerapias = await terapiasService.getAll(params);
      this.sinCompletar = responseTerapias.numSinCompletar
      this.sinMsp = responseTerapias.numSinCobertura
      if(!responseTerapias.solicitudes) return;
      const terapiasMap = responseTerapias.solicitudes.map( t => terapiasMapper(t));

      console.log("all terapias", terapiasMap)
      this.terapiasShow = terapiasMap;
    },
    
    async descargarArchivoPdf(pdfBlob, nombreArchivo) {
      try {

        if (!pdfBlob) {
          throw new Error("No se recibió el PDF en base64.");
        }

        // Convertir base64 a Blob
        const byteCharacters = atob(pdfBlob);
        const byteNumbers = Array.from(byteCharacters).map(c => c.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });

        // Crear enlace de descarga
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${nombreArchivo}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

      } catch (error) {
        console.error("Error al generar el PDF:", error);
        this.$swal("Error", "No se pudo generar el informe", "error");
      }
    },

    async generar005Terapia(tokenTerapia, paciente) {
      const pdfBlob = await terapiasService.generar005Terapias(tokenTerapia)
      let nombreArchivo = `${paciente}-form-005-terapia`
      await this.descargarArchivoPdf(pdfBlob, nombreArchivo)
    },

    async generarTerapiaFisica(tokenTerapia, paciente) {
      const pdfBlob = await terapiasService.generarTerapiaFisica(tokenTerapia)
      let nombreArchivo = `${paciente}-form-terapias`
      await this.descargarArchivoPdf(pdfBlob, nombreArchivo)
    },


    onShowModalProgramar(tokenTerapia) {
      this.navigateToQuery("setDate", tokenTerapia);
    },

    onShowSesiones(tokenTerapia) {
      this.navigateToQuery("sessions", tokenTerapia);
    },

    onShowFormMsp(tokenTerapia) {
      this.navigateToQuery("msp", tokenTerapia)
    },


    onChangePage(){

    },

    navigateToQuery(queryParam, valueQuery) {
      try {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            [queryParam]: valueQuery,
          },
        });
      } catch (error) {
        console.error("Error en la navegación:", error);
      }
    },

  },
};
</script>
